import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyUpdateUserConfigurationService } from 'owa-session-store';

export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

const UPDATE_FOLDER_VIEW_STATE_DELAY_MS = 10 * 1000;

let updateFolderViewStateTimer: any = null;

/**
 * Delay update the folder view state service
 */
export default function updateFolderViewStateService() {
    const folderViewState = getUserConfiguration().ViewStateConfiguration.FolderViewState;

    if (folderViewState) {
        const serializedFolderViewState: string[] = [];

        for (let i = 0; i < folderViewState.length; i++) {
            serializedFolderViewState.push(folderViewState[i]);
        }

        // Save this changes with a timer so we can batch all of them together.
        if (!updateFolderViewStateTimer) {
            updateFolderViewStateTimer = setTimeout(function () {
                // Clear the time handle.
                updateFolderViewStateTimer = null;

                // Make the call.
                lazyUpdateUserConfigurationService.importAndExecute(
                    [
                        {
                            key: 'FolderViewState',
                            valuetype: 'StringArray',
                            value: serializedFolderViewState,
                        },
                    ],
                    VIEW_STATE_CONFIGURATION
                );
            }, UPDATE_FOLDER_VIEW_STATE_DELAY_MS);
        }
    }
}
